module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAr0lEQVQokZ3QsUpCARjF8eNtyalHaG6KHIIgXAKfQLAnkB6h2bGlxUki6CFydY1WRxdxylyLhqKfy00ud1Dyv37n/8E5DVwnGSX5SvKd7RwkOUoyCFoY4NNufnGP82CCbvlgvEV6QRsdjIO38vCAU9xgXhFWuMUJ7vCDj9RCC/RxhiEecYEeppXcsi7+8YwrXOKp7FZl2cA8yfGONeu8F/8UNhRJmnt4h0WS1z3E2RqnrxMYSiV8DgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/email.png
// module id = By+w
// module chunks = 1